import React from 'react'
import {EditGuesser} from '@api-platform/admin'
import {TextInput, NumberInput} from 'react-admin';
import {useTranslation} from "react-i18next";

function Edit(props) {
    const {t} = useTranslation()

    return (
        <EditGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <NumberInput source="foreignId" label={'foreignId'}/>
        </EditGuesser>
    )
}

export default Edit
